import styled from 'styled-components';

const Text = styled.div`
  font-size: 14px;
  color: #191919;
  margin: 0;
  font-weight: 400;
`;

export default Text;
